import React, { Component } from "react";
import EmptyState from "@atlaskit/empty-state";

import "./noData.css";
export default class NoData extends Component {
  render() {
    return (
      <div className="empty-state">
        <EmptyState
          header={
            this.props.title
              ? this.props.title
              : this.props.topic
                ? `no ${this.props.topic} data`
                : "no data"
          }
          description={
            this.props.description
              ? this.props.description
              : this.props.topic
                ? `No ${this.props.topic} data was provided`
                : "No data was provided."
          }
          size="narrow"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoData/NoData.js